import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { signInFromTokens } from 'data/auth/actions'
import { setActiveModal } from 'data/ui/actions'
import { getAuthError } from 'data/auth/selectors'
import DesktopHelpers from 'helpers/DesktopHelpers'
import { selectors as ConfigSelectors } from 'data/config'
import AppLoading from 'components/Layout/AppLoading'
import { Text } from 'components/base'
import { getReturnToFromLocation } from './utils'
import { DESKTOP_REDIRECTION } from 'components/Utils/Modal/constants'

function getLocationParams() {
  return Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  )
}

class AutoSignIn extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    error: PropTypes.object,
    boardingAppRoot: PropTypes.string.isRequired,
    signInFromTokens: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const isDesktopRedirection = getLocationParams().loginOrigin === 'desktop'
    if (isDesktopRedirection && !DesktopHelpers.isAppDesktop()) {
      window.location = `${window.location.href.replace(
        window.location.protocol,
        'slite:'
      )}`
      this.props.setActiveModal({ id: DESKTOP_REDIRECTION })
    }
    this.startSignIn({
      isDesktopRedirection,
    })
  }

  startSignIn({ isDesktopRedirection = false } = {}) {
    const { appDomain } = this.props
    const { apiToken, renewalToken } = getLocationParams()

    const returnTo = isDesktopRedirection
      ? null
      : getReturnToFromLocation(window.location, appDomain)

    this.props.signInFromTokens({
      returnTo,
      tokens: {
        apiToken,
        renewalToken,
      },
    })
  }

  render() {
    const { error, boardingAppRoot } = this.props
    if (error) {
      return (
        <div
          className="margin-left-auto margin-right-auto border-small border-shade-50 margin-huge padding-large"
          style={{ width: 470 }}
        >
          <div className="flexbox flexbox-column">
            <div className="flexbox-grow flexbox flexbox-align-center scroll-y">
              <div className="width-full margin-bottom-large">
                <Text.Section>Oups, an error happened</Text.Section>
              </div>
            </div>
            <div
              href="/organization/create"
              className="margin-top-auto font-size-smaller shade-20"
            >
              <a
                className="shade-20 font-weight-large primary-on-hover"
                href={`${boardingAppRoot}/organization/select`}
              >
                Join another team
              </a>
            </div>
          </div>
        </div>
      )
    }
    return <AppLoading />
  }
}

export default connect(
  state => ({
    error: getAuthError(state),
    boardingAppRoot: ConfigSelectors.getBoardingAppRoot(state),
    appDomain: ConfigSelectors.getAppDomain(state),
  }),
  { signInFromTokens, setActiveModal }
)(AutoSignIn)
